import React, { useState } from 'react'
import CaLogo from "../../../images/CA-Icon.svg"
import ReactSVG from "react-svg"
import { Image } from "semantic-ui-react"
import CrossWhiteLogo from "../../../images/cross-white.svg"
import RightLogo from "../../../images/dashboard/right_arrow.svg"
import { useTranslation } from "react-i18next"
import { openInNewTab } from '../../../shared_component/utils/commonHelpers'
import { isIOS } from 'react-device-detect'
import { APP_STORE_APP, PLAY_STORE_APP } from '../../../v1/constants/fuelcardRequest'

const DownloadFuelcardBanner = () => {
  const { t } = useTranslation("fuelcardRequest")

  const [isVisible, setIsVisible] = useState(true)

  const handleBannerVisibility = () => {
    setIsVisible(prev => !prev)
  }

  return isVisible ? (
    <div className='download-fuelcard-banner'>
      <Image className='ca-logo' src={CaLogo} />
      <ReactSVG className='close-logo' onClick={handleBannerVisibility} src={CrossWhiteLogo} />
      <div className='download-fuelcard-banner-content'>
        <p className='active-your-card'>{t("activateYourCard")}</p>
        <p onClick={() => {
          openInNewTab(isIOS ? APP_STORE_APP : PLAY_STORE_APP)
        }} className='download-app'>{t("downloadApp")}  <ReactSVG className='right-logo' src={RightLogo} wrapper='span' /> </p>
      </div>
    </div>
  ) : null
}

export default DownloadFuelcardBanner
